import { useEffect, useState } from "react"
import { msg, t } from "@lingui/core/macro"
import { useParams } from "react-router-dom"
import { CAUTION_PASSWORD } from "../constants"
import { Inbox } from "../Inbox/Inbox"
import { MessageList } from "../MessageList/MessageList"
import { SearchUsers } from "../SearchUsers/SearchUsers"
import styles from "./UnifiedChat.module.scss"

const NO_MESSAGE_SELECTED = msg`Please select a conversation to start or send a new message.`

export const UnifiedChat = () => {
    const [showNewMessage, setShowNewMessage] = useState<boolean>()
    const [lastUserName, setLastUserName] = useState<string>()
    const { username } = useParams<{ username: string }>()

    const newMessageHandler = () => {
        setShowNewMessage(true)
    }

    useEffect(() => {
        if (username !== lastUserName) {
            setLastUserName(username)
            setShowNewMessage(false)
        }
    }, [username])

    const getRightSideComponent = () => {
        if (showNewMessage) {
            return <SearchUsers />
        } else if (username) {
            // key is used to force re-rendering of the MessageList component
            return <MessageList key={username} />
        } else {
            return (
                <div className={styles.emptyText}>
                    <h1>{t(NO_MESSAGE_SELECTED)}</h1>
                    <h2>{t(CAUTION_PASSWORD)}</h2>
                </div>
            )
        }
    }

    return (
        <div className={styles.container}>
            <Inbox onClose={() => {}} onNewMessage={newMessageHandler} />

            <div className={styles.verticalLine} />

            {getRightSideComponent()}
        </div>
    )
}
